import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Link as MuiLink,
} from '@material-ui/core'
import classNames from 'classnames'

import CONFIG from '../config'
import Link from './controls/Link'
import { withTracking } from './Tracking'
import Footer from './authentication/Footer'

import BloksOutlineImage from '../../assets/images/hero_graphic_solution.svg'
import Logo from '../../assets/images/logo/b_badge_stroked_dark.png'
import Logotype from '../../assets/images/logo/blok_logotype@2x.png'

class NoMatch extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    logo: {
      height: 72,
    },
    logotype: {
      height: 72,
    },
    link: theme.introLink,
    contentColumnContainer: {
      minHeight: '100vh',
      backgroundColor: '#FFD850',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(${BloksOutlineImage})`,
      flexWrap: 'nowrap',
      transition: 'transform 0.3s ease',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
      },
    },
    contentRotate: {
      transform: 'rotate(180deg)',
    },
    promptContainer: {
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(2, 0),
      },
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(3, 0),
      },
      flexGrow: 1,
    },
  })

  state = {
    rotated: false,
  }

  toggleRotate = () => {
    this.setState(
      (prevState) => ({
        rotated: !prevState.rotated,
      }),
    )
  }

  render() {
    const { classes } = this.props
    const { rotated } = this.state

    let containerClassname = classes.contentColumnContainer
    if (rotated) {
      containerClassname = classNames(containerClassname, classes.contentRotate)
    }

    return (
      <Grid container direction="column" justify="center" className={containerClassname}>
        <Grid item container justify="space-between" alignItems="center">
          <Grid item>
            <Link to={CONFIG.blokable.marketingBaseUrl}>
              <img src={Logo} alt="Blokable" className={classes.logo} />
              <img src={Logotype} alt="Blokable" className={classes.logotype} />
            </Link>
          </Grid>
          <Grid item>
            <MuiLink href="/" className={classes.link}>
              Back to BlokSense
            </MuiLink>
          </Grid>
        </Grid>
        <Grid item container className={classes.promptContainer} direction="column" justify="center" alignItems="center">
          <p><MuiLink href="#" onClick={this.toggleRotate} className={classes.link}>Oops</MuiLink></p>
          <p>Sorry, but the page you’re looking for doesn’t exist.</p>
        </Grid>
        <Grid item>
          <Footer />
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(NoMatch.styles)(withTracking(NoMatch))
